export const fakeDatas = [
  { Nation: 'US', Account: 'ju*****@gmail.com', withdrawal: '$638.75' },
  { Nation: 'CA', Account: 'la*****@gmail.com', withdrawal: '$767.43' },
  { Nation: 'GB', Account: 'si*****@gmail.com', withdrawal: '$728.69' },
  { Nation: 'FR', Account: 'ch*****@outlook.com', withdrawal: '$679.08' },
  { Nation: 'VN', Account: 'hi*****@gmail.com', withdrawal: '$821.35' },
  { Nation: 'ID', Account: 'cl*****@gmail.com', withdrawal: '$946.13' },
  { Nation: 'ID', Account: 'xi*****@gmail.com', withdrawal: '$792.86' },
  { Nation: 'US', Account: 'li*****@gmail.com', withdrawal: '$639.67' },
  { Nation: 'GB', Account: 'da*****@gmail.com', withdrawal: '$519.03' },
  { Nation: 'FR', Account: 'el*****@gmail.com', withdrawal: '$698.36' },
  { Nation: 'VN', Account: 'sa*****@outlook.com', withdrawal: '$817.78' },
  { Nation: 'ID', Account: 'ma*****@gmail.com', withdrawal: '$548.68' },
  { Nation: 'CA', Account: 'ja*****@gmail.com', withdrawal: '$728.83' },
  { Nation: 'ID', Account: 'fa*****@gmail.com', withdrawal: '$826.48' },
  { Nation: 'US', Account: 'ge*****@gmail.com', withdrawal: '$895.12' },
  { Nation: 'GB', Account: 'da*****@outlook.com', withdrawal: '$738.04' },
  { Nation: 'FR', Account: 'ch*****@gmail.com', withdrawal: '$783.99' },
  { Nation: 'VN', Account: 'mi*****@gmail.com', withdrawal: '$781.11' },
  { Nation: 'ID', Account: 'be*****@gmail.com', withdrawal: '$856.76' },
  { Nation: 'ID', Account: 'ha*****@gmail.com', withdrawal: '$998.72' },
  { Nation: 'US', Account: 'al*****@gmail.com', withdrawal: '$754.79' },
  { Nation: 'CA', Account: 'mi*****@gmail.com', withdrawal: '$902.17' },
  { Nation: 'GB', Account: 're*****@gmail.com', withdrawal: '$592.83' },
  { Nation: 'FR', Account: 'al*****@outlook.com', withdrawal: '$908.73' },
  { Nation: 'VN', Account: 'na*****@gmail.com', withdrawal: '$707.71' },
  { Nation: 'ID', Account: 'be*****@gmail.com', withdrawal: '$762.80' },
  { Nation: 'ID', Account: 'mi*****@gmail.com', withdrawal: '$708.88' },
  { Nation: 'CA', Account: 'da*****@gmail.com', withdrawal: '$960.83' },
  { Nation: 'US', Account: 'kr*****@gmail.com', withdrawal: '$779.27' },
  { Nation: 'ID', Account: 'br*****@gmail.com', withdrawal: '$973.61' },
  { Nation: 'ID', Account: 'xi*****@outlook.com', withdrawal: '$533.86' },
  { Nation: 'GB', Account: 'st*****@gmail.com', withdrawal: '$650.13' },
  { Nation: 'FR', Account: 'ma*****@gmail.com', withdrawal: '$751.96' },
  { Nation: 'VN', Account: 'ak*****@gmail.com', withdrawal: '$884.26' },
  { Nation: 'US', Account: 'an*****@outlook.com', withdrawal: '$882.87' },
  { Nation: 'ID', Account: 'ro*****@gmail.com', withdrawal: '$881.54' },
  { Nation: 'CA', Account: 'lo*****@gmail.com', withdrawal: '$869.79' },
  { Nation: 'ID', Account: 'qi*****@outlook.com', withdrawal: '$898.38' },
  { Nation: 'GB', Account: 'ca*****@gmail.com', withdrawal: '$799.12' },
  { Nation: 'FR', Account: 'fa*****@gmail.com', withdrawal: '$563.29' },
  { Nation: 'VN', Account: 'yo*****@gmail.com', withdrawal: '$739.97' },
  { Nation: 'US', Account: 'li*****@gmail.com', withdrawal: '$748.42' },
  { Nation: 'ID', Account: 'da*****@gmail.com', withdrawal: '$821.95' },
  { Nation: 'CA', Account: 'jo*****@outlook.com', withdrawal: '$713.23' },
  { Nation: 'ID', Account: 'ya*****@gmail.com', withdrawal: '$886.44' },
  { Nation: 'GB', Account: 'ka*****@gmail.com', withdrawal: '$697.60' },
  { Nation: 'FR', Account: 're*****@gmail.com', withdrawal: '$643.11' },
  { Nation: 'VN', Account: 'to*****@gmail.com', withdrawal: '$587.19' },
  { Nation: 'US', Account: 'an*****@gmail.com', withdrawal: '$772.44' },
  { Nation: 'ID', Account: 'le*****@outlook.com', withdrawal: '$715.12' },
  { Nation: 'CA', Account: 'st*****@gmail.com', withdrawal: '$594.14' },
  { Nation: 'ID', Account: 'xi*****@gmail.com', withdrawal: '$720.25' },
  { Nation: 'GB', Account: 'ja*****@gmail.com', withdrawal: '$993.46' },
  { Nation: 'FR', Account: 'cl*****@gmail.com', withdrawal: '$982.23' },
  { Nation: 'VN', Account: 'sa*****@outlook.com', withdrawal: '$971.13' },
  { Nation: 'ID', Account: 'ch*****@gmail.com', withdrawal: '$794.71' },
  { Nation: 'CA', Account: 'lo*****@gmail.com', withdrawal: '$967.54' },
  { Nation: 'ID', Account: 'li*****@gmail.com', withdrawal: '$727.79' },
  { Nation: 'FR', Account: 'ch*****@gmail.com', withdrawal: '$907.06' },
  { Nation: 'GB', Account: 'ma*****@outlook.com', withdrawal: '$702.54' },
  { Nation: 'VN', Account: 'no*****@gmail.com', withdrawal: '$978.31' },
  { Nation: 'US', Account: 'cr*****@gmail.com', withdrawal: '$935.80' },
  { Nation: 'ID', Account: 'mi*****@gmail.com', withdrawal: '$695.71' },
  { Nation: 'CA', Account: 'ke*****@gmail.com', withdrawal: '$690.26' },
  { Nation: 'ID', Account: 'wa*****@outlook.com', withdrawal: '$556.26' },
  { Nation: 'FR', Account: 'gi*****@gmail.com', withdrawal: '$792.91' },
  { Nation: 'GB', Account: 'ja*****@gmail.com', withdrawal: '$558.17' },
  { Nation: 'VN', Account: 'mi*****@gmail.com', withdrawal: '$905.22' },
  { Nation: 'US', Account: 'lo*****@gmail.com', withdrawal: '$721.90' },
  { Nation: 'ID', Account: 'me*****@outlook.com', withdrawal: '$883.21' },
  { Nation: 'CA', Account: 'ch*****@gmail.com', withdrawal: '$795.44' },
  { Nation: 'ID', Account: 'li*****@gmail.com', withdrawal: '$911.97' },
  { Nation: 'FR', Account: 'se*****@outlook.com', withdrawal: '$998.19' },
  { Nation: 'GB', Account: 'ka*****@gmail.com', withdrawal: '$785.28' },
  { Nation: 'VN', Account: 'ma*****@gmail.com', withdrawal: '$796.35' },
  { Nation: 'US', Account: 'an*****@outlook.com', withdrawal: '$646.89' },
  { Nation: 'ID', Account: 'ja*****@gmail.com', withdrawal: '$776.17' },
]